module.exports = __webpack_public_path__ + "img/293-5251a9.png";